import { gql } from '@apollo/client';

export const VERIFY_WALLET_TOKEN = gql`
  query verifyWalletToken($input: VerifyWalletTokenInput!) {
    verifyWalletToken(input: $input) {
      status
      message
      walletTokenId
    }
  }
`;
